import { combineReducers, compose, createStore as createReduxStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import systemReducer from './reducer';

export const history = createBrowserHistory();

export default function createStore() {
  const reducer = combineReducers({
    router: connectRouter(history),
    system: systemReducer,
  });

  const middlewares = [routerMiddleware(history), thunk];

  const enchancers = [applyMiddleware(...middlewares)];

  // Use Redux DevTools extension if it is installed
  let composeEnchancers = compose;
  if (process.env.NODE_ENV && process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
    composeEnchancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
  }
  const enchance = composeEnchancers(...enchancers);

  const store = createReduxStore(reducer, {}, enchance);

  return store;
}
